<div class="listCSVPhone lst">
  <!-- country + counts -->
  <div class="countryToolbar lst__bar">
    <div class="lst__intro">
      <label for="defaultCountry" id="lst-country-label" class="lst__label">Default country</label>
      <p class="lst__hint">
        Numbers without a country code, such as ones starting with 0, are read as
        this country's numbers.
      </p>
    </div>

    <!-- searchable country dropdown -->
    <div
      #countryBox
      class="countrySelect lst__country"
      (clickOutside)="closeCountryDropdown()"
      (keydown.escape)="onCountryEscape($event)"
      (focusout)="onCountryFocusOut($event)"
    >
      <button
        #countryTrigger
        type="button"
        id="defaultCountry"
        class="lst__picker"
        aria-haspopup="listbox"
        aria-labelledby="lst-country-label lst-country-value"
        [attr.aria-expanded]="countryDropdownOpen"
        [attr.aria-controls]="countryDropdownOpen ? 'lst-country-options' : null"
        (click)="toggleCountryDropdown()"
      >
        <span class="lst__picked" id="lst-country-value">
          @if (selectedCountryInfo) {
          {{ selectedCountryInfo.name }}
          <span class="lst__dial">{{ selectedCountryInfo.dialCode }}</span>
          } @else {
          <span class="lst__none">No default: international format only</span>
          }
        </span>
        <span class="bk-sym lst__chev" [class.is-open]="countryDropdownOpen" aria-hidden="true"
          >expand_more</span
        >
      </button>

      @if (countryDropdownOpen) {
      <div #countryMenu class="lst__menu" (keydown)="onCountryMenuKeydown($event)">
        <div class="lst__search">
          <span class="bk-sym" aria-hidden="true">search</span>
          <input
            #countrySearchInput
            type="text"
            [(ngModel)]="countrySearch"
            placeholder="Search country or code"
            aria-label="Search country or code"
            aria-controls="lst-country-options"
            autocomplete="off"
          />
        </div>

        <ul class="lst__options" id="lst-country-options" role="listbox" aria-label="Default country">
          <li role="none">
            <button
              type="button"
              role="option"
              class="lst__option"
              [class.is-selected]="!selectedCountry"
              [attr.aria-selected]="!selectedCountry"
              (click)="selectCountry('')"
            >
              <span class="lst__none">No default: international format only</span>
            </button>
          </li>
          @for (country of filteredCountries; track country.code) {
          <li role="none">
            <button
              type="button"
              role="option"
              class="lst__option"
              [class.is-selected]="country.code === selectedCountry"
              [attr.aria-selected]="country.code === selectedCountry"
              (click)="selectCountry(country.code)"
            >
              <span class="lst__name">{{ country.name }}</span>
              <span class="lst__dial">{{ country.dialCode }}</span>
            </button>
          </li>
          }
        </ul>
        @if (!filteredCountries.length) {
        <p class="lst__empty">No country matches “{{ countrySearch }}”</p>
        }
      </div>
      }
    </div>

    <!-- counts -->
    <div class="lst__counts" aria-live="polite">
      <app-status [text]="validCount.toLocaleString() + ' valid'" status="success" />
      @if (invalidCount > 0) {
      <app-status [text]="invalidCount.toLocaleString() + ' invalid'" status="failed" />
      }
    </div>
  </div>

  <!-- numbers -->
  <div class="listItemContents lst__body">
    <p class="lst__tip">
      Select a number to edit it. Invalid numbers are marked with a red dot.
    </p>
    <ul #numberList class="phoneNumbers lst__numbers">
      @for(phoneNumber of phoneNumbers; track $index){
      <li class="phoneNumber lst__num" [class.is-invalid]="phoneNumber.isValid === false">
        <button
          type="button"
          class="lst__value"
          [attr.aria-label]="
            'Edit ' +
            (phoneNumber.phoneNumber || 'empty row') +
            (phoneNumber.isValid === false ? ', invalid' : '')
          "
          (click)="openUpdateModal(phoneNumber)"
        >
          @if (phoneNumber.isValid === false) {
          <span class="lst__dot" aria-hidden="true"></span>
          }
          <span class="number">{{ phoneNumber.phoneNumber || '(empty)' }}</span>
        </button>
        <button
          type="button"
          class="removeIcon lst__remove"
          [attr.aria-label]="'Remove ' + (phoneNumber.phoneNumber || 'empty row')"
          (click)="removeNumber(phoneNumber.id, $index)"
        >
          <span class="bk-sym" aria-hidden="true">close</span>
        </button>
      </li>
      }
    </ul>
  </div>

  <!-- MODALS -->
  <modal-form-container
    [showModal]="showUpdateModal"
    title="Edit phone number"
    (closeModalEvent)="closeUpdateModal()"
  >
    <div class="updatePhoneNumberBody lst__edit">
      <p class="lst__hint">Change the number, then save. It is checked again straight away.</p>

      <form action="" [formGroup]="phoneNumberForm" (ngSubmit)="updatePhoneNumber()" class="lst__form">
        <input-field
          label="Phone number"
          labelClass=""
          [errorMessage]="
            phoneNumberSubmitted && phoneNumberForm.controls.phoneNumber.invalid
              ? 'Enter a valid phone number, including the country code.'
              : ''
          "
          class="w-full"
        >
          <ngx-mat-input-tel
            formControlName="phoneNumber"
            [enablePlaceholder]="true"
            [preferredCountries]="['bw', 'za']"
            [enableSearch]="true"
          />
        </input-field>

        <div class="lst__form-actions">
          <button type="button" class="bk-btn bk-btn--ghost" (click)="closeUpdateModal()">Close</button>
          <button type="submit" class="bk-btn bk-btn--primary">Save number</button>
        </div>
      </form>
    </div>
  </modal-form-container>
</div>
